// extracted by mini-css-extract-plugin
export default {"container":"chartDescription_container__Q92+b","icon":"chartDescription_icon__2gLla","label":"chartDescription_label__xcAbt","description":"chartDescription_description__hW7p6"};